import { gql } from '@apollo/client';

export const GET_VISITA_EXCEDE_CAPACITACIONES = gql`
    query GetVisitaExcedeCapacitaciones($idVisita: Int!) {
        visitaExcedeCantidadCapacitaciones(idVisita: $idVisita)
    }
`;